"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Validations = require("../../Validations");

var _Elements = require("../../Components/Elements");

var _Components = require("../../Components");

var _Utilities = require("../../Utilities");

var _Icon = _interopRequireDefault(require("../../../Icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DateInput = function DateInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      _onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      value = _ref.value,
      validations = _ref.validations,
      submitAttempted = _ref.submitAttempted,
      isRequired = _ref.isRequired,
      attr = _ref.attr,
      placeholder = _ref.placeholder,
      clearable = _ref.clearable,
      clear = _ref.clear,
      onClick = _ref.onClick,
      noSpacing = _ref.noSpacing,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      format = _ref.format;
  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  var focusRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_Elements.InputWrapper, {
    className: errorId ? 'form-error' : ''
  }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    id: "".concat(id, "-label"),
    isRequired: isRequired,
    htmlFor: id
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledDatePickerWrapper, {
    ref: focusRef,
    name: name,
    id: id,
    value: value,
    onChange: function onChange(val) {
      _onChange({
        name: name,
        value: val
      });
    },
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    attr: _objectSpread({
      'aria-labelledby': "".concat(id, "-label"),
      'aria-invalid': errorId ? true : undefined,
      'aria-required': isRequired ? true : undefined
    }, attr),
    onClick: onClick,
    clearIcon: null,
    calendarIcon: null,
    dayPlaceholder: "dd",
    monthPlaceholder: "mm",
    yearPlaceholder: "yyyy",
    dayAriaLabel: "Day",
    monthAriaLabel: "Month",
    yearAriaLabel: "Year",
    format: format,
    minDate: minDate,
    maxDate: maxDate
  }), clearable ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "close",
    size: "xs",
    className: "clear",
    tabIndex: 0,
    "aria-label": "Press to clear ".concat(id, "."),
    onClick: function onClick() {
      clear({
        name: name
      });
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        var _focusRef$current;

        event.preventDefault();
        clear({
          name: name
        }); // eslint-disable-next-line no-unused-expressions

        focusRef === null || focusRef === void 0 ? void 0 : (_focusRef$current = focusRef.current) === null || _focusRef$current === void 0 ? void 0 : _focusRef$current.focus();
      }
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    noSpacing: noSpacing,
    id: errorId,
    values: {
      inputName: label
    }
  }));
};

DateInput.Validations = {
  required: _Validations.required
};
DateInput.propTypes = {
  placeholder: _propTypes["default"].string,
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].object,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  attr: _propTypes["default"].shape({}),
  isRequired: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  clearable: _propTypes["default"].bool,
  clear: _propTypes["default"].func,
  noSpacing: _propTypes["default"].bool,
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  format: _propTypes["default"].string
};
DateInput.defaultProps = {
  attr: {},
  isRequired: false,
  validations: {},
  placeholder: '',
  clearable: false,
  clear: function clear() {},
  onClick: function onClick() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  noSpacing: false,
  minDate: null,
  maxDate: null,
  format: 'yyyy-M-d'
};
var MemoInput = (0, _memoizeFormElement["default"])(DateInput);

var _default = (0, _Form.asFormElement)(MemoInput);

exports["default"] = _default;